module.exports = __webpack_public_path__ + "static/media/emojis2_01.d14f8f5e.svg";